import BaseService from '@/network/base-service'
// import FetchMock from '../helpers/fetch-mock'

// const SOLICITACOES_MOCK = [{
//   cd_solicitacao: 1,
//   descricao: 'Cirurgia de Ortopedia',
//   dtSolicitacao: '03/01/2023',
//   situacao: 'Agendada',
//   unidade: 'Brasília'
// },
// {
//   cd_solicitacao: 2,
//   descricao: 'Cirurgia de Ortopedia',
//   dtSolicitacao: '05/06/2023',
//   situacao: 'Na fila de espera',
//   unidade: 'Brasília'
// },
// {
//   cd_solicitacao: 3,
//   descricao: 'Cirurgia de Ortopedia',
//   dtSolicitacao: '12/09/2023',
//   situacao: 'Agendada',
//   unidade: 'Brasília'
// }]

class CirugiaService extends BaseService {
  constructor () {
    super(`${process.env.VUE_APP_API_BASE_URL}/paciente/paciente/cirurgias`)
  }

  getSolicitacoes () {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/paciente/cirurgias?dtHrSolicitacao=&cdCirurgia=`, {
      method: 'GET'
    })
  }

  getSolicitacao (dtHrSolicitacao, cdCirurgia) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/paciente/cirurgias?dtHrSolicitacao=${dtHrSolicitacao}&cdCirurgia=${cdCirurgia}`, {
      method: 'GET'
    })
  }

  getSituacoes (cdCirurgia) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/paciente/situacoesCirurgia?cdCirurgia=${cdCirurgia}`, {
      method: 'GET'
    })
  }

  getSituacoesDaSolicitacao (dtCirurgia) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/paciente/situacoesCirurgia?DtHrSolicitacao=${dtCirurgia}`, {
      method: 'GET'
    })
  }

  getTempoEspera (cirurgia) {
    return fetch(`${process.env.VUE_APP_API_BASE_URL}/paciente/paciente/temposCirurgia?CdCirurgia=${cirurgia.CdCirurgia}&DtHrSolicitacao=${cirurgia.DtHrSolicitacao}`, {
      method: 'GET'
    })
  }

  faleConosco(cirurgia, mensagem) {
    return this.post('faleconosco', {
      cdCirurgia: cirurgia.CdCirurgia,
      dtHrSolicitacao: cirurgia.DtHrSolicitacao,
      mensagem: mensagem
    })
  }
}

export default new CirugiaService()
